import { useFormContext } from 'react-hook-form';

import { HookFormText } from 'components/hookForm';

import { AttributeFormFieldValues } from '../../../customAttributeModalForm.types';

const maxLength = 65536;

/** Represents the field for providing a description for a custom attribute. */
export const DescriptionFormField = (): JSX.Element => {
  const {
    control,
    formState: { isSubmitting },
    // TODO: [TEAMS-13693] remove omit after updating to RHF v8
  } = useFormContext<Omit<AttributeFormFieldValues, 'options'>>();

  return (
    <HookFormText
      control={control}
      label="Description"
      name="description"
      disabled={isSubmitting}
      helpIcon={{
        text: 'Text that describes what the custom attribute represents',
        dark: true,
      }}
      rules={{
        maxLength: {
          value: maxLength,
          message: `Must not exceed ${maxLength} characters`,
        },
      }}
      componentProps={{
        placeholder: 'The customer order number',
      }}
    />
  );
};
